<kendo-dialog [width]="300">
  @if (loading) {
    <maximizer-loader type="legacy"></maximizer-loader>
  }

  <div class="scollbar narrow">
    <div class="flex justify-between items-center pb-2">
      <p class="subtitle-1">
        {{ 'outlook.sync.settings.title' | translate }}
      </p>
      <button
        id="outlook-sync-ui-settings-closeIcon"
        kendoButton
        themeColor="primary"
        fillMode="flat"
        iconClass="fa-icons icon-xmark icon-14"
        [attr.aria-label]="'outlook.buttons.close' | translate"
        (click)="openSyncSettings.emit(false)"
        class="small"
      ></button>
    </div>
    <p class="text-body">
      {{ 'outlook.sync.settings.subtitle1' | translate }}
    </p>
    <p class="text-body">
      {{ 'outlook.sync.settings.subtitle2' | translate }}
    </p>
    <form [formGroup]="form.group">
      <div class="settings-table scrollbar">
        <!-- Email -->
        <div class="flex flex-col gap-1">
          <div class="flex justify-between items-center pb-1">
            <div class="flex gap-2 items-baseline">
              <span
                [ngClass]=""
                class="fa-icons icon-16 icon-envelope text-neutral-90"
              ></span>
              <p class="subtitle-1">
                {{ 'outlook.sync.settings.email.title' | translate }}
              </p>
            </div>
            <div class="flex items-center gap-2">
              @if (status.email.message) {
                <span
                  kendoTooltip
                  position="bottom"
                  [tooltipTemplate]="tooltipTemplate"
                  position="top"
                  [callout]="false"
                  [title]="status.email.message"
                  [class]="status.email.code | syncStatusIcon"
                  class="fa-icons icon-14"
                ></span>
              } @else {
                <span
                  [class]="status.email.code | syncStatusIcon"
                  class="fa-icons icon-14"
                ></span>
              }
              @if (disabled.email) {
                <kendo-switch
                  formControlName="email"
                  kendoTooltip
                  position="bottom"
                  [tooltipTemplate]="tooltipTemplate"
                  [tooltipWidth]="250"
                  position="top"
                  [callout]="false"
                  [title]="
                    'outlook.rights.adminMessageAlt'
                      | translate
                        : {
                            right:
                              'outlook.rights.insert' | translate | titlecase,
                            entry: 'outlook.entries.emails' | translate,
                          }
                  "
                ></kendo-switch>
              } @else {
                <kendo-switch
                  id="outlook-sync-ui-settings-emailSwitch"
                  formControlName="email"
                  (valueChange)="onEmailSyncChange()"
                ></kendo-switch>
              }
            </div>
          </div>
          <p class="caption text-neutral-70 mt-1">
            {{ 'outlook.sync.settings.email.subtitle' | translate }}
          </p>
          <p class="text-body text-neutral-70 pt-1">
            {{ 'outlook.sync.settings.email.description' | translate }}
          </p>
          <div class="flex flex-col text-body mt-2">
            <span>{{
              'outlook.sync.settings.email.scope.title' | translate
            }}</span>
            <kendo-dropdownlist
              id="outlook-sync-ui-settings-emailScopeDropdown"
              formControlName="emailScope"
              [data]="emailScopeList"
              valueField="id"
              textField="name"
              [valuePrimitive]="true"
            >
              <ng-template kendoDropDownListValueTemplate let-dataItem>
                <span class="text-body">{{ dataItem?.name | translate }}</span>
              </ng-template>
              <ng-template kendoDropDownListItemTemplate let-dataItem>
                <span class="text-body">{{ dataItem.name | translate }}</span>
              </ng-template>
            </kendo-dropdownlist>
          </div>
        </div>
        <!-- Calendar -->
        <div class="flex flex-col gap-1">
          <div class="flex justify-between items-center pb-1">
            <div class="flex gap-2 items-baseline">
              <span
                class="fa-icons icon-16 icon-calendar-days text-neutral-90"
              ></span>
              <p class="subtitle-1">
                {{ 'outlook.sync.settings.calendar.title' | translate }}
              </p>
            </div>
            <div class="flex items-center gap-2">
              @if (status.appointment.message) {
                <span
                  kendoTooltip
                  position="bottom"
                  [tooltipTemplate]="tooltipTemplate"
                  position="top"
                  [callout]="false"
                  [title]="status.appointment.message"
                  [class]="status.appointment.code | syncStatusIcon"
                  class="fa-icons icon-14"
                ></span>
              } @else {
                <span
                  [class]="status.appointment.code | syncStatusIcon"
                  class="fa-icons icon-14"
                ></span>
              }
              <kendo-switch
                id="outlook-sync-ui-settings-calendarSwitch"
                formControlName="appointment"
                [title]=""
              ></kendo-switch>
            </div>
          </div>
          <p class="caption text-neutral-70">
            {{ 'outlook.sync.settings.calendar.subtitle' | translate }}
          </p>
          <p class="text-body text-neutral-70 pt-1">
            {{ 'outlook.sync.settings.calendar.description' | translate }}
          </p>
        </div>
        <!-- Contacts -->
        <div class="flex flex-col gap-1">
          <div class="flex justify-between items-center pb-1">
            <div class="flex gap-2 items-baseline">
              <span
                class="fa-icons icon-16 icon-address-book text-neutral-90"
              ></span>
              <p class="subtitle-1">
                {{ 'outlook.sync.settings.contacts.title' | translate }}
              </p>
            </div>
            <div class="flex items-center gap-2">
              @if (status.contact.message) {
                <span
                  kendoTooltip
                  position="bottom"
                  [tooltipTemplate]="tooltipTemplate"
                  position="top"
                  [callout]="false"
                  [title]="status.contact.message"
                  [class]="status.contact.code | syncStatusIcon"
                  class="fa-icons icon-14"
                ></span>
              } @else {
                <span
                  [class]="status.contact.code | syncStatusIcon"
                  class="fa-icons icon-14"
                ></span>
              }
              @if (disabled.contact) {
                <kendo-switch
                  formControlName="contact"
                  kendoTooltip
                  position="bottom"
                  [tooltipTemplate]="contactSyncTooltip"
                  position="top"
                  [callout]="false"
                  [tooltipWidth]="250"
                  [title]="'outlook.rights.genericMessage' | translate"
                ></kendo-switch>
                <ng-template #contactSyncTooltip let-anchor>
                  <div class="flex flex-col gap-1">
                    @if (!this.userRights?.addressBook?.insert) {
                      <p class="caption text-neutral-90">
                        {{
                          'outlook.rights.adminMessageAlt'
                            | translate
                              : {
                                  right:
                                    'outlook.rights.insert'
                                    | translate
                                    | titlecase,
                                  entry: 'outlook.entries.entries' | translate,
                                }
                        }}
                      </p>
                    }
                    @if (!this.userRights?.addressBook?.update) {
                      <p class="caption text-neutral-90">
                        {{
                          'outlook.rights.adminMessageAlt'
                            | translate
                              : {
                                  right:
                                    'outlook.rights.modify'
                                    | translate
                                    | titlecase,
                                  entry: 'outlook.entries.entries' | translate,
                                }
                        }}
                      </p>
                    }
                    @if (!this.userRights?.syncContacts) {
                      <p class="caption text-neutral-90">
                        {{
                          'outlook.rights.adminMessageAlt'
                            | translate
                              : {
                                  right:
                                    'outlook.rights.syncContacts' | translate,
                                  entry: 'outlook.entries.entries' | translate,
                                }
                        }}
                      </p>
                    }
                  </div>
                </ng-template>
              } @else {
                <kendo-switch
                  id="outlook-sync-ui-settings-contactSwitch"
                  formControlName="contact"
                  (valueChange)="onContactSyncChange()"
                ></kendo-switch>
              }
            </div>
          </div>

          <p class="caption text-neutral-70">
            {{ 'outlook.sync.settings.contacts.subtitle' | translate }}
          </p>
          <p class="text-body text-neutral-70 pt-1">
            {{ 'outlook.sync.settings.contacts.description' | translate }}
          </p>
          <kendo-label
            [text]="'outlook.sync.settings.contacts.label' | translate"
            class="text-body pt-1"
          >
            <kendo-dropdownlist
              id="outlook-sync-ui-settings-contactDropdown"
              formControlName="favoriteList"
              [data]="favoriteLists"
              valueField="id"
              textField="name"
              [valuePrimitive]="true"
              class="text-body"
            >
              <ng-template kendoDropDownListItemTemplate let-dataItem>
                <p class="text-body">{{ dataItem.name }}</p>
              </ng-template>
            </kendo-dropdownlist>
          </kendo-label>
        </div>
        <!-- Tasks -->
        <div class="flex flex-col gap-1">
          <div class="flex justify-between items-center pb-1">
            <div class="flex gap-2 items-baseline">
              <span
                class="fa-icons icon-16 icon-circle-check text-neutral-90"
              ></span>
              <p class="subtitle-1">
                {{ 'outlook.sync.settings.tasks.title' | translate }}
              </p>
            </div>
            <div class="flex items-center gap-2">
              @if (status.task.message) {
                <span
                  kendoTooltip
                  position="bottom"
                  [tooltipTemplate]="tooltipTemplate"
                  position="top"
                  [callout]="false"
                  [title]="status.task.message"
                  [class]="status.task.code | syncStatusIcon"
                  class="fa-icons icon-14"
                ></span>
              } @else {
                <span
                  [class]="status.task.code | syncStatusIcon"
                  class="fa-icons icon-14"
                ></span>
              }
              <kendo-switch
                id="outlook-sync-ui-settings-tasksSwitch"
                formControlName="task"
              ></kendo-switch>
            </div>
          </div>
          <p class="caption text-neutral-70">
            {{ 'outlook.sync.settings.tasks.subtitle' | translate }}
          </p>
          <p class="text-body text-neutral-70 pt-1">
            {{ 'outlook.sync.settings.tasks.description' | translate }}
          </p>
        </div>
      </div>
      <div class="flex justify-between gap-2 flex-wrap">
        <button
          id="outlook-sync-ui-settings-syncHistory"
          kendoButton
          themeColor="primary"
          fillMode="flat"
          (click)="openOutlookSyncHistory()"
        >
          {{ 'outlook.sync.settings.history' | translate }}
        </button>
        <div class="flex gap-1">
          <button
            id="outlook-sync-ui-settings-close"
            kendoButton
            themeColor="secondary"
            class="uppercase"
            (click)="openSyncSettings.emit(false)"
          >
            {{ 'outlook.buttons.close' | translate }}
          </button>
          <button
            id="outlook-sync-ui-settings-save"
            kendoButton
            themeColor="primary"
            class="uppercase"
            [disabled]="!form.valid || loading || !form.group.dirty"
            (click)="updateSyncSettings()"
          >
            {{ 'outlook.buttons.save' | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
</kendo-dialog>

<maximizer-outlook-notification #notification [closable]="true">
</maximizer-outlook-notification>

<ng-template #tooltipTemplate let-anchor>
  <p class="caption text-neutral-90">
    {{ anchor.nativeElement.getAttribute('data-title') }}
  </p>
</ng-template>
